"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALID_TYPE_PROPS = exports.VALID_SIZE_PROPS = exports.DEFAULT_ICON_MARGIN = exports.DEFAULT_PADDING = exports.DEFAULT_LETTER_SPACING = exports.DEFAULT_LINE_HEIGHT = exports.DEFAULT_FONT_WEIGHT = exports.DEFAULT_FONT_SIZE = exports.DEFAULT_COLOR = exports.DEFAULT_BORDER_RADIUS = exports.DEFAULT_BACKGROUND_COLOR = exports.DEFAULT_TYPE_PROP = exports.DEFAULT_SIZE_PROP = void 0;
var DEFAULT_SIZE_PROP = 'rg';
exports.DEFAULT_SIZE_PROP = DEFAULT_SIZE_PROP;
var DEFAULT_TYPE_PROP = 'default';
exports.DEFAULT_TYPE_PROP = DEFAULT_TYPE_PROP;
var DEFAULT_BACKGROUND_COLOR = 'bayBlue30';
exports.DEFAULT_BACKGROUND_COLOR = DEFAULT_BACKGROUND_COLOR;
var DEFAULT_BORDER_RADIUS = '4px';
exports.DEFAULT_BORDER_RADIUS = DEFAULT_BORDER_RADIUS;
var DEFAULT_COLOR = 'greys.charcoal';
exports.DEFAULT_COLOR = DEFAULT_COLOR;
var DEFAULT_FONT_SIZE = '14px';
exports.DEFAULT_FONT_SIZE = DEFAULT_FONT_SIZE;
var DEFAULT_FONT_WEIGHT = 'normal';
exports.DEFAULT_FONT_WEIGHT = DEFAULT_FONT_WEIGHT;
var DEFAULT_LINE_HEIGHT = '20px';
exports.DEFAULT_LINE_HEIGHT = DEFAULT_LINE_HEIGHT;
var DEFAULT_LETTER_SPACING = '0.57px';
exports.DEFAULT_LETTER_SPACING = DEFAULT_LETTER_SPACING;
var DEFAULT_PADDING = '4px 12px';
exports.DEFAULT_PADDING = DEFAULT_PADDING;
var DEFAULT_ICON_MARGIN = '2px 8px 0px 0px';
exports.DEFAULT_ICON_MARGIN = DEFAULT_ICON_MARGIN;
var VALID_SIZE_PROPS = ['rg', 'sm', 'xs'];
exports.VALID_SIZE_PROPS = VALID_SIZE_PROPS;
var VALID_TYPE_PROPS = ['corner', 'default', 'placeholder', 'success', 'warning'];
exports.VALID_TYPE_PROPS = VALID_TYPE_PROPS;